var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAction = function SvgAction(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 102.125,
    y1: 66.066811,
    x2: 102.125,
    y2: 97.14238,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(76.862746%,81.960785%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 16.125,
    x2: 86,
    y2: 157.922882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(80.392158%,83.92157%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(32.941177%,47.843137%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 95.40625,
    y1: 16.125,
    x2: 95.40625,
    y2: 157.922882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(80.392158%,83.92157%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(32.941177%,47.843137%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1875,
    y1: 16.125,
    x2: 67.1875,
    y2: 157.922882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(80.392158%,83.92157%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(32.941177%,47.843137%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9317847"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 34.375 28.125 L 28.125 28.125 C 28.125 26.398438 26.726562 25 25 25 L 25 18.75 C 30.179688 18.75 34.375 22.945312 34.375 28.125 Z M 34.375 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 38.691406 17.75 L 40.925781 15.511719 C 41.535156 14.90625 41.535156 13.914062 40.925781 13.304688 L 39.820312 12.199219 C 39.210938 11.589844 38.21875 11.589844 37.613281 12.199219 L 35.375 14.433594 C 32.683594 12.390625 29.375 11.117188 25.78125 10.957031 L 25.78125 9.375 L 27.34375 9.375 C 28.207031 9.375 28.90625 8.675781 28.90625 7.8125 L 28.90625 6.25 C 28.90625 5.386719 28.207031 4.6875 27.34375 4.6875 L 22.65625 4.6875 C 21.792969 4.6875 21.09375 5.386719 21.09375 6.25 L 21.09375 7.8125 C 21.09375 8.675781 21.792969 9.375 22.65625 9.375 L 24.21875 9.375 L 24.21875 10.957031 C 15.101562 11.367188 7.8125 18.910156 7.8125 28.125 C 7.8125 37.601562 15.523438 45.3125 25 45.3125 C 34.476562 45.3125 42.1875 37.601562 42.1875 28.125 C 42.1875 24.230469 40.882812 20.632812 38.691406 17.75 Z M 22.65625 6.25 L 27.34375 6.25 L 27.34375 7.8125 L 22.65625 7.8125 Z M 39.023438 27.34375 C 38.628906 20.214844 32.910156 14.496094 25.78125 14.101562 L 25.78125 12.539062 C 33.773438 12.9375 40.1875 19.351562 40.585938 27.34375 Z M 25 40.625 C 18.109375 40.625 12.5 35.015625 12.5 28.125 C 12.5 21.234375 18.109375 15.625 25 15.625 C 31.890625 15.625 37.5 21.234375 37.5 28.125 C 37.5 35.015625 31.890625 40.625 25 40.625 Z M 38.714844 13.304688 L 39.820312 14.410156 L 37.6875 16.542969 C 37.335938 16.15625 36.96875 15.789062 36.582031 15.4375 Z M 24.21875 12.539062 L 24.21875 14.101562 C 17.089844 14.496094 11.371094 20.214844 10.976562 27.34375 L 9.414062 27.34375 C 9.8125 19.351562 16.226562 12.9375 24.21875 12.539062 Z M 9.414062 28.90625 L 10.976562 28.90625 C 11.371094 36.035156 17.089844 41.753906 24.21875 42.148438 L 24.21875 43.710938 C 16.226562 43.3125 9.8125 36.898438 9.414062 28.90625 Z M 25.78125 43.710938 L 25.78125 42.148438 C 32.910156 41.753906 38.628906 36.035156 39.023438 28.90625 L 40.585938 28.90625 C 40.1875 36.898438 33.773438 43.3125 25.78125 43.710938 Z M 25.78125 43.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 34.375 28.90625 L 34.375 27.34375 L 28.828125 27.34375 C 28.515625 25.816406 27.308594 24.609375 25.78125 24.296875 L 25.78125 18.75 L 24.21875 18.75 L 24.21875 24.296875 C 22.4375 24.660156 21.09375 26.238281 21.09375 28.125 C 21.09375 30.277344 22.847656 32.03125 25 32.03125 C 26.886719 32.03125 28.464844 30.6875 28.828125 28.90625 Z M 25 30.46875 C 23.707031 30.46875 22.65625 29.417969 22.65625 28.125 C 22.65625 26.832031 23.707031 25.78125 25 25.78125 C 26.292969 25.78125 27.34375 26.832031 27.34375 28.125 C 27.34375 29.417969 26.292969 30.46875 25 30.46875 Z M 25 30.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 15.625 28.125 L 14.0625 28.125 C 14.0625 34.15625 18.96875 39.0625 25 39.0625 L 25 37.5 C 19.832031 37.5 15.625 33.292969 15.625 28.125 Z M 15.625 28.125 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action.5d107445.svg";
export { ForwardRef as ReactComponent };